import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select, { components } from "react-select";
import i18n from "../i18n";
import { apiChangeLanguage } from "../services/UsersService";

// styles
require("./LanguageSelector.css");

const { Option, SingleValue } = components;
const IconOption = props => (
    <Option {...props}>
        <i className={props.data.icon} />
        {props.data.label}
    </Option>
);

const ValueOption = props => (
    <SingleValue {...props}>
        <i className={props.data.icon} />
    </SingleValue>);

const options = [
    { value: 'bg', label: 'български', icon: "bg flag" },
    { value: 'cs', label: 'čeština', icon: "cz flag" },
    { value: 'sk', label: 'Slovenčina', icon: "sk flag" },
    { value: 'en', label: 'English', icon: "gb uk flag" },
    { value: 'ru', label: 'Русский', icon: "ru flag" },
    { value: 'ua', label: 'Yкраїнська', icon: "ua flag" },
    { value: 'hr', label: 'Magyar', icon: "hu flag" },
    { value: 'pl', label: 'Polski', icon: "pl flag" },
    { value: 'cr', label: 'Hrvatski', icon: "hr flag" }
]

const LanguageSelector = () => {
    const [selectedLanguage, setSelectedLanguage] = useState<any>({ value: 'cs', label: 'čeština', icon: "cz flag" });

    const userInfo = useSelector((state: any) => state.userInfo);
    useEffect(() => {
        if (userInfo.Language !== selectedLanguage.value) {
            const lang = options.find(l => { return l.value === userInfo.Language });
            if (lang) {
                setSelectedLanguage(lang);
                i18n.changeLanguage(lang.value);
            }
        }
    }, [userInfo.Language]);

    const handleLanguageChange = (val: any) => {
        setSelectedLanguage(val);
        i18n.changeLanguage(val.value);
        if (userInfo && !userInfo.Anonymous) {
            apiChangeLanguage(val.value);
        }
    }
    return (
        <>
            <div className="language-selector" >
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={options}
                    components={{ Option: IconOption, SingleValue: ValueOption }}
                    value={selectedLanguage}
                    onChange={handleLanguageChange}
                />
            </div>
        </>
    );
};

export default LanguageSelector;
